import React from "react";
import { startOfDay, sub } from "date-fns";
import { HXCircleIcon, OnboardDueDateCard } from "@aph/ui-lib-humanx";
import DatePicker from "@/components/Picker/Date";
import styles from "@/components/PageHome/components/OnboardingSection/Flows/Flows.module.scss";

interface PeriodDateProps {
  heading?: any;
  description?: any;
  bgIcon?: React.ReactNode;
  ctaText?: string;
  ctaClick: (date: Date) => void;
  ctaBelowText?: any;
  initialDate?: Date;
  dateLimits?: number[];
}

const initialData = {
  heading: {
    prefixText: (
      <span>
        <strong>Awesome!</strong> Let’s start this beautiful journey together
      </span>
    ),
  },
  description: {
    prefixText: (
      <span>
        Tell us <strong>when you’re last period started and</strong> know when you’re most fertile
      </span>
    ),
  },
  ctaText: "Next",
  ctaBelowText: "",
  initialDate: sub(startOfDay(new Date()), { days: 13 }),
  bgIcon: <HXCircleIcon iconStyle={"style1"} className={styles["bgIconTopRight"]} />,
  dateLimits: [40],
};

const PeriodDate: React.FC<PeriodDateProps> = (props) => {
  const {
    heading = initialData.heading,
    description = initialData.description,
    bgIcon = initialData.bgIcon,
    ctaText = initialData.ctaText,
    ctaClick,
    ctaBelowText = initialData.ctaBelowText,
    initialDate = initialData.initialDate,
    dateLimits = initialData.dateLimits,
  } = props;
  const [date, setDate] = React.useState<Date>();

  const handleSubmit = (): void => {
    if (ctaClick && typeof ctaClick === "function") {
      ctaClick(date);
    }
  };

  return (
    <>
      <OnboardDueDateCard
        titleText={heading}
        subTitleText={description}
        backgroundCard={bgIcon}
        middleSection={
          <DatePicker fullWidth={false} setDate={setDate} initialDate={initialDate} daysLimit={dateLimits} />
        }
        ctaText={ctaText}
        ctaClick={handleSubmit}
        ctaBelowText={ctaBelowText}
      />
    </>
  );
};

export default PeriodDate;
